import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'hc-hygiene-check-statistical',
  templateUrl: './hygiene-check-statistical.component.html',
  styleUrls: ['./hygiene-check-statistical.component.css']
})
export class HygieneCheckStatisticalComponent implements OnInit {

  constructor(private router: Router, public config: AppConfig) { }

  ngOnInit(): void {
  }

  onChildData(event: any) {
    switch (event.key) {
      case 'quickComments': this.router.navigate(['evaluation/hygiene-check/quickComments']); break;
      case 'overallCompliance': this.router.navigate(['evaluation/hygiene-check/overallCompliance']); break;
      case 'individualData': this.router.navigate(['evaluation/hygiene-check/individualData']); break;
      default: this.router.navigate(['evaluation/hygiene-check/statistical']); break;
    }
  }
}
